import React from "react";
import { HiOutlineExclamation } from "react-icons/hi";
import SecureStorage from "../../utils/secureStorage";

const ImpersonationBanner: React.FC = () => {
  if (!SecureStorage.isImpersonating()) {
    return null;
  }

  const session = SecureStorage.getImpersonationSession();
  const ownerLabel =
    session?.entity_identification || session?.user_identification || "";

  const handleExit = () => {
    SecureStorage.clearImpersonationSession();
    window.close();
    window.location.href = "/impersonation-ended";
  };

  return (
    <div className="w-full bg-amber-500 text-white px-4 py-2 flex items-center justify-between gap-3 shadow">
      <div className="flex items-center gap-2 text-sm font-medium">
        <HiOutlineExclamation size={20} className="shrink-0" />
        <span>
          Support session: you are acting as the account owner
          {ownerLabel ? ` (${ownerLabel})` : ""}
        </span>
      </div>
      <button
        type="button"
        onClick={handleExit}
        className="bg-white text-amber-700 hover:bg-amber-50 text-sm font-semibold rounded-md px-3 py-1 shrink-0"
      >
        Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
